import React from 'react';

const IconPinterest: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    focusable='false'
    role='presentation'
    fill='none'
    {...props}
    className={`icon icon-pinterest${props.className ? ' ' + props.className : ''}`}
  >
    <path
      d='M11.7948 1.375C7.9365 1.375 4.125 3.94625 4.125 8.10837C4.125 10.7552 5.61412 12.2609 6.5175 12.2609C6.88875 12.2609 7.10325 11.2214 7.10325 10.9285C7.10325 10.5793 6.21225 9.83537 6.21225 8.37925C6.21225 5.357 8.51263 3.21337 11.4909 3.21337C14.0511 3.21337 15.9459 4.66813 15.9459 7.3425C15.9459 9.339 15.1456 13.0831 12.5496 13.0831C11.6146 13.0831 10.813 12.4066 10.813 11.4373C10.813 10.0155 11.8058 8.63912 11.8058 7.17338C11.8058 4.68463 8.27475 5.13562 8.27475 8.14275C8.27475 8.77525 8.3545 9.47375 8.63638 10.0499C8.11663 12.2829 7.0565 15.6104 7.0565 17.9107C7.0565 18.6216 7.15825 19.3215 7.22563 20.0324C7.3535 20.1754 7.29025 20.1602 7.4855 20.0874C9.38025 17.4941 9.31287 16.9868 10.1695 13.5919C10.6329 14.4719 11.8278 14.9449 12.7751 14.9449C16.7681 14.9449 18.5625 11.0536 18.5625 7.546C18.5625 3.81288 15.3354 1.375 11.7948 1.375Z'
      fill=''
    />
  </svg>
);
export default IconPinterest;
